import { render, staticRenderFns } from "./ThirdPartyInformationCN.vue?vue&type=template&id=3ed13867"
import script from "./ThirdPartyInformationCN.vue?vue&type=script&lang=js"
export * from "./ThirdPartyInformationCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports